import React from "react";
import { Bluetooth } from "lucide-react";
import TakeOutTransmitterImg from "src/assets/images/cgm/connection-journey/take-out-transmitter.png";
import SearchingGif from "src/assets/images/cgm/connection-journey/searching.gif";
import CgmDeviceBlankImg from "src/assets/images/cgm/connection-journey/cgm-device-blank.svg";

import type { CgmDeviceFoundPayload } from "src/types/cgm.types";
import Button from "../../Button";

type ScanningStepProps = {
  scannedDevices: CgmDeviceFoundPayload[];
  onSelectDevice: (device: CgmDeviceFoundPayload) => void;
};

const ScanningStep: React.FC<ScanningStepProps> = ({
  scannedDevices,
  onSelectDevice,
}) => {
  return (
    <div className="px-4 py-4 flex flex-col items-center gap-4 w-full">
      <h1 className="text-2xl font-semibold text-black">
        Connect to your Transmitter
      </h1>
      <p className="text-sm text-gray-500 text-center">
        Remove the transmitter from the charging pod and our app will detect it
      </p>

      <img
        src={TakeOutTransmitterImg}
        alt="Take out transmitter"
        className="w-full h-auto mt-6"
      />

      {scannedDevices.length > 0 ? (
        <div className="space-y-2 w-full">
          {scannedDevices.map((d) => (
            <div
              key={d.pocDevice.address}
              className="w-full flex items-center justify-between gap-3 p-4 rounded-xl bg-[var(--icon-bg-primary)]"
            >
              <div className="flex items-center gap-3">
                <img
                  src={CgmDeviceBlankImg}
                  alt="CGM Device"
                  className="w-12 h-12 object-contain"
                />
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-gray-900 truncate">
                    {d.pocDevice.name || "CGM Reader"}
                  </h3>
                  <p className="text-xs text-gray-500">Signal: {d.rssi} dBm</p>
                </div>
              </div>

              <Button
                onClick={() => onSelectDevice(d)}
                variant="contained"
                rounded="full"
                size="md"
              >
                Connect
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full flex items-center gap-4 bg-[#EEF4FF] p-4 rounded-lg">
          <img src={SearchingGif} alt="Searching" className="w-12 h-12" />
          <p className="text-sm text-gray-500">Searching for your device...</p>
        </div>
      )}
    </div>
  );
};

export default ScanningStep;
